import { observer } from "mobx-react-lite";
import React, { useState } from "react";
import { useStore } from "../../app/stores/store";
import '../Pagos/Operaciones_style.css'
import { TableWithBrowserPagination, Column, Badge } from 'react-rainbow-components';
import styled from 'styled-components'
import context from "react-bootstrap/esm/AccordionContext";
import { isEmptyArray } from "formik";
import LoadingComponent from "../../app/layout/LoadingComponent";

const StyledBadge = styled(Badge)`color: #1de9b6;`;
const StatusBadge = ( value:any ) => <StyledBadge label={value} variant="lightest" />;
const containerStyles = { height: 312 };

export default observer(function TablaReporteInscritos() {

  const { ReporteInscritosStore } = useStore();

  return (

    <div className="rainbow-p-bottom_xx-large">
      
        <TableWithBrowserPagination
          isLoading={ReporteInscritosStore.loadingInitial}
          paginationAlignment="left"
          pageSize={20}
          data={ReporteInscritosStore.ReporteInscritosByCodigo}
          keyField="id" showRowNumberColumn={false}
          emptyDescription={false}
          emptyTitle={<span>No se encontraron resultados</span>}
        >

        <Column header="Código de curso" field="codigoCuenta" />
        <Column header="Nombre" field="nombreCompleto" />
        <Column header="CUI" field="dpi" />
        <Column header="Curso" field="nombre" />

        </TableWithBrowserPagination>
      
    </div>
  )
})